import React, {useEffect, useState} from 'react';
import {Route, Routes, useLocation} from "react-router";
import Header from "./components/Header";
import Preloader from "./components/Preloader";
import Home from "./components/Home";
import Hakkimizda from "./components/Hakkimizda";
import DijitalNetwork from "./components/DijitalNetwork";
import Iletisim from "./components/Iletisim";
import Giris from "./components/Giris";
import Footer from "./components/Footer";
import Hedefleme from "./components/Hedefleme";
import {ToastContainer} from "react-toastify";

function App() {
    const location = useLocation();


    return (
        <React.Fragment>
            <Preloader/>

                {location.pathname!=="/giris" && <Header/>}
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/hakkimizda" element={<Hakkimizda/>}/>
                    <Route path="/dijital-network" element={<DijitalNetwork/>}/>
                    <Route path="/iletisime-gecin" element={<Iletisim/>}/>
                    <Route path="/giris" element={<Giris/>}/>
                    <Route path="/hedefleme-seceneklerimiz" element={<Hedefleme/>}/>
                </Routes>
            <Footer/>
            <ToastContainer />
        </React.Fragment>
    );
}

export default App;